<template>
    <Switch
        @click="toggle"
        :disabled="disabled"
        :checked="checked"
        :class="[
            checked ? checkedColor : uncheckedColor, // bg-gray-100 when unchecked
            { 'bg-opacity-25 cursor-not-allowed': disabled || loading },
            height,
            width,
            'transition-colors duration-300 ease-in-out', // Transition for bg-color
        ]"
        class="relative inline-flex items-center rounded-full"
    >
        <span
            :class="[
                { 'translate-x-[180%] ': checked },
                { 'translate-x-[20%]': !checked },
                { 'animate-pulse': loading },
                triggerColor,
                'w-1/3 aspect-square',
                'absolute transition-all duration-300 ease-in-out', // Transition for toggle position
            ]"
            class="inline-block transform rounded-full transition"
        />
    </Switch>
</template>

<script>
import { Switch } from '@headlessui/vue'

export default {
    name: 'ToggleSwitch',

    components: {
        Switch,
    },

    props: {
        checked: {
            type: Boolean,
            default: false,
        },
        height: {
            type: String,
            default: 'h-6',
        },
        width: {
            type: String,
            default: 'w-11',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        checkedColor: {
            type: String,
            default: 'bg-primary',
        },
        uncheckedColor: {
            type: String,
            default: 'bg-gray-100',
        },
        triggerColor: {
            type: String,
            default: 'bg-white',
        },
    },

    methods: {
        toggle() {
            if (this.disabled) {
                return
            }

            this.$emit('clicked', !this.checked)
        },
    },
}
</script>
